import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import {useToasts} from "@brg/ui";

export const NotificationNewPromoCode: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const promoInfo = actions[0]?.fieldValues;
    const toasts = useToasts();

    const promocode = promoInfo["promoCode"] || promoInfo["PromoCode"];
    const projectLink = promoInfo["projectLink"] || promoInfo["ProjectLink"];
    const projectName = promoInfo["projectName"] || promoInfo["ProjectName"];
    const competitionLink = promoInfo["competitionLink"] || promoInfo["CompetitionLink"];
    const competitionName = promoInfo["competitionName"] || promoInfo["CompetitionName"];

    const onCopy = (e: any) => {
        e.preventDefault()
        e.stopPropagation()
        navigator.clipboard
            .writeText(promocode)
            .then(() => toasts.info('Промокод скопирован'));
    }

    if (!promoInfo) return null;

    // Ваш проект [название проекта] был принят на конкурс Кто здесь модный?
    // Мы дарим вам скидочный промокод на заказ в приложении Самокат: [номер промокода]

    return <SimpleTitle>
        {`  Ваш проект `}
        <a href={projectLink}>{projectName}</a>
        {` был принят на конкурс `}
        <a href={competitionLink}>{competitionName}</a>
        {` Мы дарим вам скидочный промокод на заказ в приложении Самокат: `}<a onClick={onCopy}>{promocode}</a>
    </SimpleTitle>

    // { "ProjectLink", projectUrl },
    // { "ProjectName", projectName },
    // { "CompetitionLink", competitionUrl },
    // { "CompetitionName", competitionName },
    // { "PromoCode", promoTicket.PromoCode },
    // { "PromoInfoId", promoInfo.PromoInfoId },
    // { "Lang","Ru" }
}import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import {useToasts} from "@brg/ui";

export const NotificationNewPromoCode: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const promoInfo = actions[0]?.fieldValues;
    const toasts = useToasts();

    const promocode = promoInfo["promoCode"] || promoInfo["PromoCode"];
    const projectLink = promoInfo["projectLink"] || promoInfo["ProjectLink"];
    const projectName = promoInfo["projectName"] || promoInfo["ProjectName"];
    const competitionLink = promoInfo["competitionLink"] || promoInfo["CompetitionLink"];
    const competitionName = promoInfo["competitionName"] || promoInfo["CompetitionName"];

    const onCopy = (e: any) => {
        e.preventDefault()
        e.stopPropagation()
        navigator.clipboard
            .writeText(promocode)
            .then(() => toasts.info('Промокод скопирован'));
    }

    if (!promoInfo) return null;

    // Ваш проект [название проекта] был принят на конкурс Кто здесь модный?
    // Мы дарим вам скидочный промокод на заказ в приложении Самокат: [номер промокода]

    return <SimpleTitle>
        {`  Ваш проект `}
        <a href={projectLink}>{projectName}</a>
        {` был принят на конкурс `}
        <a href={competitionLink}>{competitionName}</a>
        {` Мы дарим вам скидочный промокод на заказ в приложении Самокат: `}<a onClick={onCopy}>{promocode}</a>
    </SimpleTitle>

    // { "ProjectLink", projectUrl },
    // { "ProjectName", projectName },
    // { "CompetitionLink", competitionUrl },
    // { "CompetitionName", competitionName },
    // { "PromoCode", promoTicket.PromoCode },
    // { "PromoInfoId", promoInfo.PromoInfoId },
    // { "Lang","Ru" }
}